export { default } from './HeartOutline'
